import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-134a4b50"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "logo"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "headerSpace"
};
const _hoisted_5 = {
  class: "header-space-right-menu"
};
const _hoisted_6 = {
  class: "logout-block__label"
};
const _hoisted_7 = {
  key: 1,
  class: "lang-separator"
};
const _hoisted_8 = {
  class: "lang-dropdown"
};
const _hoisted_9 = {
  class: "selected-item-container"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_icon = _resolveComponent("w-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isAuth() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "menuContainer",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.toggleMenu && _ctx.toggleMenu(...args))
  }, [_createVNode(_component_w_icon, {
    icon: _ctx.isMenuVisible ? 'backburger' : 'menu',
    size: "20px",
    class: "iconMenu"
  }, null, 8, ["icon"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
    to: "/",
    class: "logo__link"
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      src: _ctx.logoPath
    }, null, 8, _hoisted_3)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_ctx.isAuth() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "logout-block",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.logoutUser())
  }, [_createVNode(_component_w_icon, {
    icon: "logout",
    class: "logout-block__picto"
  }), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('header.logout_label')), 1)])) : _createCommentVNode("", true), _ctx.isAuth() ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_dropdown, {
    placement: "bottom",
    size: "small",
    trigger: "click",
    onCommand: _ctx.onLangChanges
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languagesDropdownItems, item => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.key,
          command: item.key
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, [_createElementVNode("div", {
            class: _normalizeClass(`icon-language ${item.icon}`)
          }, null, 2)])]),
          _: 2
        }, 1032, ["command"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languagesDropdownItems, item => {
      return _openBlock(), _createElementBlock("span", null, [_createElementVNode("div", {
        class: _normalizeClass(`icon-language ${!item.isSelected ? 'icon-language--hide' : ''} ${item.icon}`)
      }, null, 2)]);
    }), 256))])]),
    _: 1
  }, 8, ["onCommand"])])])]), _hoisted_10]);
}